import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

export enum UnreadIndicatorSize {
  SMALL = 'small',
  MID = 'mid',
}

@Component({
  selector: 'fl-unread-indicator',
  template: `
    <fl-bit
      class="UnreadIndicator"
      [attr.aria-label]="ariaLabel"
      [attr.data-size]="size"
    ></fl-bit>
  `,
  styleUrls: ['./unread-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnreadIndicatorComponent {
  @Input() ariaLabel: string;

  @HostBinding('attr.data-size')
  @Input()
  size = UnreadIndicatorSize.MID;
}
